const ajaxurl = data_handler.ajaxurl;

const DOMElements = {
	checkSessionIdDiv: '#check-session-id',
	checkSessionIdButton: '#check-session-id__button',
	checkSessionIdInput: '#check-session-id__input',
	sessionIdInput: '#session_id',
	sessionErrorMessage: '#session-error-message',
	formCreateGroupTrigger: '#create-group-trigger',
};

const checkSessionIdDiv = document.querySelector(DOMElements.checkSessionIdDiv),
	checkSessionIdButton = document.querySelector(
		DOMElements.checkSessionIdButton
	),
	checkSessionIdInput = document.querySelector(
		DOMElements.checkSessionIdInput
	),
	sessionIdInput = document.querySelector(DOMElements.sessionIdInput),
	sessionErrorMessage = document.querySelector(
		DOMElements.sessionErrorMessage
	),
	formCreateGroupTrigger = document.querySelector(
		DOMElements.formCreateGroupTrigger
	);

const checkSessionId = () => {
	checkSessionIdAjax(checkSessionIdInput.value);
};

const checkSessionIdAjax = (sid) => {
	const request = new XMLHttpRequest();
	request.open('POST', ajaxurl, true);
	request.setRequestHeader(
		'Content-Type',
		'application/x-www-form-urlencoded;'
	);
	request.setRequestHeader('Access-Control-Allow-Headers', '*');
	request.onreadystatechange = function () {
		if (this.readyState === 4 && this.status === 200) {
			if (this.response === '1') {
				displayAddTeamForm(sid);
			} else {
				window.scrollTo(0, 0);
				displayAddPrimaryKeyError();
			}
		}
	};
	request.send('action=check_session_id_ajax&sid=' + sid);
};

const displayAddPrimaryKeyError = () => {
	sessionErrorMessage.classList.toggle('session-error-message-hidden');
	setTimeout(() => {
		sessionErrorMessage.classList.toggle('session-error-message-hidden');
	}, 4000);
};

const displayAddTeamForm = (sid) => {
	checkSessionIdDiv.classList.add('form-display-hide');
	formCreateGroupTrigger.classList.remove('form-display-toggle');
	sessionIdInput.value = sid;
};

const SessionCreateAction = {
	bindEvents: () => {
		if (checkSessionIdButton) {
			checkSessionIdButton.addEventListener('click', checkSessionId);
		}
		if (checkSessionIdInput) {
			checkSessionIdInput.addEventListener('keyup', (e) => {
				if (e.keyCode === 13) {
					e.preventDefault();
					checkSessionId();
				}
			});
		}
	},
};

export default SessionCreateAction;
